/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPRODUCTTYPE = {
    Local: '1',
    Offshore: '2'
} as const;
export type IAPPRODUCTTYPE = typeof IAPPRODUCTTYPE[keyof typeof IAPPRODUCTTYPE];


export function IAPPRODUCTTYPEFromJSON(json: any): IAPPRODUCTTYPE {
    return IAPPRODUCTTYPEFromJSONTyped(json, false);
}

export function IAPPRODUCTTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPRODUCTTYPE {
    return json as IAPPRODUCTTYPE;
}

export function IAPPRODUCTTYPEToJSON(value?: IAPPRODUCTTYPE | null): any {
    return value as any;
}

